


















  import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
  import ACard from "@/components/UI/ACard.vue";
@Component({
  components: {
    ACard
  },
})
export default class HardwareInfo extends Vue {

  @Prop() vehicle!:any

  public getManifacturer(item:string) {
    let el = item.replace(/\\/g, '/').split('/')
    return el.pop()
  }
}
